import { urlBase } from './urls';

const feathers = require('@feathersjs/feathers');
const socketio = require('@feathersjs/socketio-client');
const io = require('socket.io-client');
const auth = require('@feathersjs/authentication-client');

const socket = io(`${urlBase}`, {
  transports: ['websocket'],
  forceNew: true
});
const client = feathers();

// Setup the transport (Rest, Socket, etc.) here
client.configure(socketio(socket,{ timeout: 60000}));

// Available options are listed in the "Options" section
client.configure(auth({
  storageKey: 'auth'
}))
// Authenticate with the local email/password strategy 
/* client.authenticate({
  strategy: 'local',
  email: 'juankurdiales@hotmail.com',
  password: 'jnk'
}).then(() => {
  // Logged in
}).catch(e => {
  // Show login page (potentially with `e.message`)
  console.error('Authentication error', e);
}); */


//const messageService = client.service('transfers');

// messageService.on('created', message => console.log('Created a message', message));




export default client;
/* import io from 'socket.io-client';
import feathers from '@feathersjs/client';
import rx from 'feathers-reactive/dist/feathers-reactive';

const socket = io('http://localhost:3023');
const client = feathers()
  .configure(feathers.socketio(socket))
  .configure(rx({
    idField: 'id'
  }));

export default client;*/ 